import { useState } from 'react';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { showToast } from '../components/ui/Toast';
import { useSiteContent } from '../context/SiteContentContext';

const colorFields = [
  { key: 'color_primary', label: 'Primary (green)' },
  { key: 'color_primary_mid', label: 'Primary mid (hover)' },
  { key: 'color_primary_light', label: 'Primary light (accents)' },
  { key: 'color_secondary', label: 'Secondary (brown)' },
  { key: 'color_secondary_mid', label: 'Secondary mid' },
  { key: 'color_accent', label: 'Accent (gold)' },
  { key: 'color_accent_light', label: 'Accent light' },
  { key: 'color_cream', label: 'Page background (cream)' },
  { key: 'color_red', label: 'Red (warnings)' },
  { key: 'color_black', label: 'Black (footer, text)' },
];

export default function AdminColours() {
  const { content, updateBulk } = useSiteContent();
  const [form, setForm] = useState({ ...content });
  const [saved, setSaved] = useState(true);

  function set(key, value) { setForm(prev => ({ ...prev, [key]: value })); setSaved(false); }
  const [saving, setSaving] = useState(false);
  async function save() {
    if (saving) return;
    setSaving(true);
    const r = await updateBulk(form);
    setSaving(false);
    if (r && r.error) { showToast(r.error, 'error'); return; }
    setSaved(true);
    showToast('Brand colours updated');
  }

  return (
    <div>
      <h1 className="adm-title">Brand colours</h1>
      <p className="adm-sub">Change a colour here and it updates everywhere on the site — nav, buttons, footer, everything.</p>

      <div className="adm-card">
        <div className="adm-card-title">Colour palette</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {colorFields.map(({ key, label }) => (
            <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <input
                type="color"
                value={form[key] || '#000000'}
                onChange={e => set(key, e.target.value)}
                style={{ width: 36, height: 30, padding: 2, borderRadius: 4, cursor: 'pointer', border: '1px solid rgba(74,46,26,0.15)' }}
              />
              <div>
                <div style={{ fontSize: 12, color: '#333' }}>{label}</div>
                <div style={{ fontSize: 10, color: '#999', fontFamily: 'monospace' }}>{form[key]}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="adm-save-bar">
        <span className={`adm-save-status ${saved ? 'adm-save-status--saved' : ''}`}>
          {saved ? '✓ Saved' : '● Unsaved'}
        </span>
        <button className="adm-btn" onClick={save}><IconDeviceFloppy size={14} /> Save</button>
      </div>
    </div>
  );
}
